import { render, staticRenderFns } from "./ResumeQuotation.vue?vue&type=template&id=51ca4fc9"
import script from "./ResumeQuotation.vue?vue&type=script&lang=js"
export * from "./ResumeQuotation.vue?vue&type=script&lang=js"
import style0 from "./ResumeQuotation.vue?vue&type=style&index=0&id=51ca4fc9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports